// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d20a8898","31":"6e95509f","390":"7738d692","896":"2f8d51ee"}[chunkId] + ".chunk.js";
};